/* 🤖 this file was generated by svg-to-ts */
export const iconGnosissdai: {
  name: 'gnosissdai';
  data: string;
} = {
  name: 'gnosissdai',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="#33453D" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#F7C04B" d="M17.24 8.01h-6.86v4.47H8.34v1.15c0 .78.63 1.42 1.42 1.42h.62v1.91h-.62c-.78 0-1.42.63-1.42 1.42v1.15h2.04v4.53h6.86a8.02 8.02 0 0 0 8.02-8.02 8.02 8.02 0 0 0-8.02-8.02zm.01 13.53h-4.31v-2.01h4.87a2.57 2.57 0 0 0 2.57-2.57h-7.44v-1.91h7.44a2.57 2.57 0 0 0-2.57-2.57h-4.87v-1.94h4.31c3.04 0 5.5 2.46 5.5 5.5s-2.46 5.5-5.5 5.5"/></svg>`,
};
